import { type ChatbotParams, FONT_ID_TO_FONT_CDN_PATH_MAP } from "@do/shared-types";

export const Fonts = ({
  cdnUrl,
  chatbotParams,
}: {
  cdnUrl: string;
  chatbotParams: Pick<ChatbotParams, "fontId" | "fonts" | "customFonts">;
}) => {
  const importedFontIds = [
    ...new Set([chatbotParams.fontId, ...(chatbotParams.fonts ?? [])]),
  ].filter((fontId): fontId is NonNullable<ChatbotParams["fontId"]> => Boolean(fontId));
  const importedFontNames = new Set(importedFontIds.map(String));
  const importedBuiltInFontUrls = new Set(
    importedFontIds.map((fontId) => `${cdnUrl}${FONT_ID_TO_FONT_CDN_PATH_MAP[fontId]}`)
  );

  return (
    <>
      {chatbotParams.fontId && chatbotParams.fontId in FONT_ID_TO_FONT_CDN_PATH_MAP && (
        <link
          href={`${cdnUrl}${
            FONT_ID_TO_FONT_CDN_PATH_MAP[
              chatbotParams.fontId as keyof typeof FONT_ID_TO_FONT_CDN_PATH_MAP
            ]
          }`}
          rel="stylesheet"
        />
      )}

      {[...new Set(chatbotParams.fonts ?? [])]
        .filter(
          (fontId) =>
            fontId && fontId !== chatbotParams.fontId && fontId in FONT_ID_TO_FONT_CDN_PATH_MAP
        )
        .map((fontId) => (
          <link
            href={`${cdnUrl}${
              FONT_ID_TO_FONT_CDN_PATH_MAP[fontId as keyof typeof FONT_ID_TO_FONT_CDN_PATH_MAP]
            }`}
            key={fontId}
            rel="stylesheet"
          />
        ))}

      {chatbotParams.customFonts &&
        Object.entries(chatbotParams.customFonts)
          .filter(
            ([key, value]) => !importedFontNames.has(key) && !importedBuiltInFontUrls.has(value)
          )
          .map(([key, value]) => <link href={value} key={key} rel="stylesheet" />)}
    </>
  );
};
